import { DEVICE_TYPE } from '../../../config/devices';
import { SITE_CATEGORY } from '../../../config/sites';
import { IDevice } from '../store/deviceStore';

export interface IUserProfileDevicesPayload {
  results?: IDevice[];
  resultsFiltered?: number;
  resultsTotal?: number;
}

export const isAcomDevice = (device: IDevice): boolean =>
  device?.type === DEVICE_TYPE.ACCESS_COMMANDER ||
  (device?.site?.type as string | undefined) === SITE_CATEGORY.ACCESS_COMMANDER_REMOTE;

export const filterUserProfileDevices = (payload: IUserProfileDevicesPayload): IUserProfileDevicesPayload => {
  const results = payload?.results ?? [];
  const kept = results.filter((device) => !isAcomDevice(device));
  const removed = results.length - kept.length;

  return {
    ...payload,
    results: kept,
    resultsFiltered: Math.max(0, (payload?.resultsFiltered ?? 0) - removed),
    resultsTotal: Math.max(0, (payload?.resultsTotal ?? 0) - removed),
  };
};
